export const setValue = value => {
  const sonarAssessment = JSON.parse(sessionStorage.getItem('sonar-assessment'))
  sessionStorage.setItem(
    `sonar-assessment`,
    JSON.stringify({ ...sonarAssessment, ...value })
  )
}

export const getSonarAssessmentValue = value => {
  const sessionStorageAttempt = getSonarAssessment()
  return sessionStorageAttempt ? sessionStorageAttempt[value] : null
}

export const getSonarAssessment = () => {
  return JSON.parse(sessionStorage.getItem('sonar-assessment'))
}

export const clearSonarAssessment = () => {
  sessionStorage.setItem(`sonar-assessment`, null)
}
